
import { Navbar } from '../components/Navbar.tsx';
import axios from "axios";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { FiCoffee } from "react-icons/fi";
import { Toaster, toast } from 'alert';
import { Footer } from "../components/Footer.tsx";

function SignUp() {
  const [password, setPassword] = useState("");
  const [email, setEmail] = useState("");
  const [username, setUsername] = useState("");
  const api = "https://backend.coffeelatek.com";
  const navigate = useNavigate();

  function submit() {
    axios.post(api + '/api/signup', {
      username: username,
      password: password,
      email: email
    }).then(
      res => {
        if (res.status == 200) {
          toast.success('registration succeeded')
          navigate("/login")
        } else {
          toast.error("an error has occured, please try again")
        }
      }
    ).catch(function (error) {
      toast.error('an error has occured, please try again')
    })
  }

  const handleCtrl = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      submit()
    }
  }

  useEffect(() => {
    if (localStorage.getItem("token") != undefined) {
      navigate("/search")
    }
    document.addEventListener('keydown', handleCtrl);
    return () => {
      document.removeEventListener('keydown', handleCtrl);
    }
  })

  const handlePassword = (e) => {
    setPassword(e.target.value)
  }
  const handleEmail = (e) => {
    setEmail(e.target.value)
  }
  const handleUsername = (e) => {
    setUsername(e.target.value)
  }

  return (
    <>
      <Navbar />
      <Toaster position='top-center' />

      <div className="login-page">
        <div className="login-card">
          <div className="logo">
            <FiCoffee size={40} color="var(--primary-color)" />
          </div>
          <h1>Create an Account</h1>
          <p className="subtitle text-muted">Join CoffeeLaTek to start writing</p>

          <div className="form-group">
            <label>Email</label>
            <input 
              placeholder="Enter your email" 
              type="email" 
              onChange={handleEmail} 
              style={{ width: '100%' }}
            />
          </div>

          <div className="form-group">
            <label>Username</label>
            <input 
              placeholder="Choose a username" 
              onChange={handleUsername} 
              style={{ width: '100%' }}
            />
          </div>

          <div className="form-group">
            <label>Password</label>
            <input 
              placeholder="Create a password" 
              type='password' 
              onChange={handlePassword} 
              style={{ width: '100%' }}
            />
          </div>

          <button className="button" style={{ width: '100%' }} onClick={submit}>
            Sign Up
          </button>

          <div className="text-center mt-2">
            <span className="text-muted">Already have an account? </span>
            <a href="/login">Log in</a>
          </div>
        </div>
      </div>

      <Footer />
    </>
  )
}

export default SignUp; 